import React from "react";
import styled from "styled-components";
import { AutoComplete } from "antd";

const SlayerMasterSearch = ({
  slayerMasters,
  onSearch,
  onSelect,
  masterIcons,
}) => {
  const masterNames = slayerMasters.map((master) => {
    return {
      value: master.master_name,
      label: master.master_img && (
        <MasterOption>
          <span>{master.master_name}</span>
          <img
            style={{ width: "20px", height: "auto", marginRight: "20px" }} // TODO
            src={masterIcons(`./${master.master_img}`)}
            alt={`OSRS ${master.master_name} Slayer Master Icon`}
          />
        </MasterOption>
      ),
    };
  });

  return (
    <SearchContainer>
      <AutoComplete
        style={{ width: 280 }}
        // popupMatchSelectWidth={232}
        placeholder="Input Slayer Master..."
        allowClear
        backfill={true}
        disabled={!masterNames.length}
        options={masterNames.length ? masterNames : []}
        onSelect={onSelect}
        onSearch={onSearch}
        onClear={() => onSelect("")}
        filterOption={(inputValue, option) =>
          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
      />
    </SearchContainer>
  );
};

export default SlayerMasterSearch;

const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const MasterOption = styled.div`
  display: flex;
  justify-content: space-between;
`;
